import { curry } from 'lodash';
import type { Alert } from 'types';
import type { MessageDescriptor } from '@lingui/core';
import { ALERTS_TRANSLATIONS } from '../i18n';

interface Translator {
  _: (message: MessageDescriptor) => string;
}

export const getAlertMessage = curry((i18n: Translator, alert: Alert) => {
  const message = ALERTS_TRANSLATIONS[alert.Code];
  const alertMessage = message ? i18n._(message) : alert.Desc;
  const error = alert.Error ? ` [${alert.Error}]` : '';
  return [alertMessage, error].join(' ');
});
